import { OptimizedImage } from './OptimizedImage';
import { extractPublicId } from '@/utils/media';

interface FeedOptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  aspectRatio?: string;
  sizes?: string;
  onClick?: () => void;
  onLoad?: () => void;
  onError?: () => void;
}

export const FeedOptimizedImage = ({ 
  src,
  alt,
  className,
  aspectRatio = "16/9",
  sizes = "(max-width: 640px) 92vw, 600px",
  onClick,
  onLoad,
  onError 
}: FeedOptimizedImageProps) => {
  const publicId = extractPublicId(src);
  
  return (
    <OptimizedImage
      publicId={publicId}
      alt={alt}
      className={className}
      aspectRatio={aspectRatio}
      sizes={sizes}
      onClick={onClick}
      onLoad={onLoad}
      onError={onError}
    />
  );
};